// Photography manifest. When new photographs arrive, place them in
// /public/images and point the matching slot at its file.
export const PHOTOS = {
  // Drop the client's hero film here (e.g. "/videos/dune-hero.mp4") to replace the photo sequence.
  heroVideo: null,
  heroSequence: [
    { src: "/images/exterior-hero.webp", alt: "Dune Villas at Area 83, the private villa exterior in warm evening light" },
    { src: "/images/courtyard-pool.webp", alt: "The private courtyard pool at a Dune Villa" },
    { src: "/images/living-room.webp", alt: "The living and dining space inside a Dune Villa" },
    { src: "/images/games-lounge.webp", alt: "The games lounge with a pool table inside a Dune Villa" },
    { src: "/images/bedroom-morning.webp", alt: "A bedroom at Dune Villas in morning light" },
    { src: "/images/courts-aerial.webp", alt: "Aerial view of the sports courts at Area 83" },
  ],
  hero: "/images/exterior-hero.webp",
  intro: "/images/living-room.webp",
  villa1: "/images/foyer.webp",
  villa2: "/images/courtyard-walk.webp",
  momentMorning: "/images/bedroom-morning.webp",
  momentLunch: "/images/long-lunch.jpg",
  momentPool: "/images/courtyard-pool.webp",
  momentCelebration: "/images/bonfire-corner.webp",
  celebration: "/images/celebration-bg.jpg",
  escape: "/images/escape-bg.jpg",
  gallery: [
    "/images/exterior-hero.webp",
    "/images/courtyard-pool.webp",
    "/images/living-room.webp",
    "/images/games-lounge.webp",
    "/images/lounge-palms.webp",
    "/images/stairwell-pendants.webp",
    "/images/bedroom-arch.webp",
    "/images/kitchen-island.webp",
    "/images/courts-aerial.webp",
  ],
};
